import SelectedIcon from "../../components/miscellaneous/selected-icon";
import AmpleHireLabelTag from "../ample-hire-html-tags/ample-hire-label-tag";
import AmpleHireSelectTag from "../ample-hire-html-tags/ample-hire-select-tag";
import getUniqueId from "../../utils/getUniqueId";

const SelectInputField = ({
  divTagCssClasses = "",
  selectTagCssClasses = "",
  optionTagClasses = "",
  selectTagIdAndName = "",
  options,
  value,
  onChange,
  multiple = false,
  disabled = false,
  firstOptionDisabled = true,
  required = false,
  selectedValues = [],
  setSelectedValues = () => { },
  handleRemoveSelectedValue = () => { },
  labelText,
  labelIconSrc = null,
  labelIconAltText = "",
  labelIconCss = "",
  missing = false,
  cutomizedCssForLabel = false,
                            customLabelNode,
  ...props
}) => {
  // Materialize select wrapping disabled — using native styled select instead

  return (
    <div className={`input-field ${missing ? "select-missing-value" : ""} ${divTagCssClasses}`}>
      <AmpleHireSelectTag
        className={selectTagCssClasses}
        optionTagClassName={optionTagClasses}
        id={selectTagIdAndName}
        name={selectTagIdAndName}
        options={options}
        value={value}
        onChange={onChange}
        multiple={multiple}
        disabled={disabled}
        firstOptionDisabled={firstOptionDisabled}
        labelText={labelText}
        {...props}
      />
      {customLabelNode ?<AmpleHireLabelTag
        htmlFor={selectTagIdAndName}
        labelText={customLabelNode}
        required={required}
        labelIconSrc={labelIconSrc}
        labelIconCss={labelIconCss}
        labelIconAltText={labelIconAltText}
        cutomizedCssForLabel={cutomizedCssForLabel}
      /> : <AmpleHireLabelTag
          htmlFor={selectTagIdAndName}
          labelText={labelText}
          required={required}
          labelIconSrc={labelIconSrc}
          labelIconCss={labelIconCss}
          labelIconAltText={labelIconAltText}
          cutomizedCssForLabel={cutomizedCssForLabel}
      />}
      {multiple &&
        selectedValues?.map((value, index) => (
          <SelectedIcon
            key={getUniqueId()}
            selectedIconText={value}
            disabled={disabled}
            onClickIcon={() =>
              handleRemoveSelectedValue(value, selectTagIdAndName)
            }
          />
        ))}
    </div>
  );
};

export default SelectInputField;
